module.exports = __webpack_public_path__ + "media/images/mobile/abouts/8-f5274927d3d1062e8181483e28a65ae4.jpg";